<template>
  <div class="add-to-calendar">
    <mks-button type="primary" size="small" @click="togglePopin"
      ><mks-icon type="plus-circle" size="16"></mks-icon>&nbsp; {{__("Ajouter à mon calendrier")}}</mks-button
    >
    <div class="popin__container">
      <Popin v-show="showPopin" @hide="hidePopin">
        <mks-list class="calendar__links">
          <mks-link class="calendar__link" :to="`${$env.apiUrl}${$env.version}/events/${id}/calendar/google`">{{__('Google calendar')}}</mks-link>
          <mks-link class="calendar__link" :to="`${$env.apiUrl}${$env.version}/events/${id}/calendar/outlook`">{{__('Outlook')}}</mks-link>
          <mks-link class="calendar__link" :to="`${$env.apiUrl}${$env.version}/events/${id}/calendar.ics`">{{__('iCal')}}</mks-link>
        </mks-list>
      </Popin>
    </div>
  </div>
</template>
<script>
import MksList from "@DS/components/List.vue";
import Popin from "@/components/molecules/Popin.vue";

export default {
    props: {
        id: String
    },
    components: {MksList, Popin},
    data() {
      return {
        showPopin: false
      }
    },
    methods: {
      togglePopin() {
        // to trigger the toggle after hidePopin is emitted by click outside in Popin.vue
        window.setTimeout(() => {
          this.showPopin = !this.showPopin;
        }, 10);

      },
      hidePopin() {
        if (this.showPopin) {
           this.showPopin = false;
        }
      }
    }
}
</script>
<style lang="scss" scoped>
.add-to-calendar {
  display: inline-block;
  position: relative;
}
.popin__container {
  position: absolute;
}
.calendar__links {
  margin-bottom: 0;
  margin-right: $space-s;
}
.calendar__link {
  @include text-body-black;
  @include inner-space('xxs', 'y');
  border-bottom: none;
  display: block;
  border-radius: $border-radius-s;

  &:hover {
    color: $color-secondary;
  }
}
</style>
